import React from "react";
import { graphql, gql, ChildProps } from "react-apollo";
import oktaClient from "app/utils/oktaClient";

import { Button, TextField, Typography } from "@material-ui/core";

import withDialog, { DialogProp } from "app/utils/withDialog";
import handleMutationError from "../../../utils/handleMutationError";

type MutationResult = {
  refund_request_cancel: {
    id: BigInt;
  };
};

type Props = ChildProps<
  {
    id: BigInt;
    reloadData: Function;
  } & DialogProp,
  MutationResult
>;

class RefundRequestsFailButton extends React.Component<Props> {
  comment = "";

  commentOnChange(nextComment: string) {
    this.comment = nextComment;
  }

  fail() {
    this.props.dialog.prompt({
      content: (
        <div>
          <Typography
            variant="h6"
            component="h5"
            style={{ marginBottom: "20px" }}
          >
            Please insert a comment in order to fail the selected refund:
          </Typography>
          <label
            style={{
              color: "black",
            }}
          >
            Comment:{" "}
          </label>
          <TextField
            multiline
            type="text"
            onChange={(event) => this.commentOnChange(event.target.value)}
            style={{
              width: "200px",
              marginRight: "10px",
            }}
          />
        </div>
      ),
      buttons: [
        {
          label: "Save",
          action: this.saveAction.bind(this),
        },
        {
          label: "Cancel",
        },
      ],
    });
  }

  saveAction() {
    this.props
      .mutate({
        variables: {
          id: this.props.id,
          user_email: oktaClient.getToken().claims.email,
          comment: this.comment,
        },
      })
      .then(this.props.reloadData())
      .catch((error) => error && handleMutationError(error));
  }

  render() {
    return (
      <Button
        style={{
          backgroundColor: "#4d5a86",
          color: "white",
        }}
        onClick={() => this.fail()}
      >
        Fail
      </Button>
    );
  }
}

const withRefundRequestFailMutation = graphql<MutationResult, Props>(
  gql`
    mutation UpdateRefundRequest(
      $id: ID!
      $user_email: String
      $comment: String
    ) {
      update_refund_request(
        id: $id
        user_email: $user_email
        comment: $comment
      ) {
        id
      }
    }
  `
);

export default withDialog(
  withRefundRequestFailMutation(RefundRequestsFailButton)
);
